import React from 'react'
import { Input, InputNumber } from 'antd'

// eslint-disable-next-line react/display-name
export default ({ data = {}, spec = {}, handleExtSave }) => {
  // const { year, unit, utility, eventNum } = data

  //  const { header1, header2, header3, header4, header5, header6, header7, header8 } = spec

  const getHeaderComp = idx => (
    <div
      style={{ display: 'grid', alignContent: 'center', justifyContent: 'end' }}
    >
      {spec[`header${idx}`]}
    </div>
  )

  const handleSave = (idx, value, isNumber) =>
    handleExtSave(isNumber ? `number${idx}` : `string${idx}`, value)

  const getComp = (idx, isNumber = false) => {
    if (!spec[`header${idx}`]) return <div />
    if (!spec.avaliable) return <div />
    if (isNumber)
      return (
        <InputNumber
          onChange={v => handleSave(idx, v, isNumber)}
          min={spec[`minVal${idx}`]}
          max={spec[`maxVal${idx}`]}
          disabled={
            spec[`header${idx}`] === 'N\\A' || spec[`header${idx}`] === 'NA'
          }
          value={data['number' + idx]}
        />
      )
    else
      return (
        <Input
          value={data['string' + idx]}
          onChange={v => handleSave(idx, v.target.value, false)}
          disabled={spec[`header${idx}`] === 'N\\A'}
        />
      )
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '100px 100px 100px 400px',
        gridGap: '5px',
      }}
    >
      {getHeaderComp(1)}
      {getComp(1, true)}

      {getHeaderComp(5)}
      {getComp(5)}

      {getHeaderComp(2)}
      {getComp(2, true)}

      {getHeaderComp(6)}
      {getComp(6)}

      {getHeaderComp(3)}
      {getComp(3, true)}

      {getHeaderComp(7)}
      {getComp(7)}

      {getHeaderComp(4)}
      {getComp(4, true)}

      {getHeaderComp(8)}
      {getComp(8)}
    </div>
  )
}
